import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '~env/environment';
import {join} from '~utils/path-util';

@Injectable({providedIn: 'root'})
export class UrlService {
    constructor(private router: Router) {}

    get baseUrl(): string {
        if (!environment.useHash) {
            return environment.appBaseHref ?? '/';
        }
        const uri = this.router.url;
        const [base] = window.location.href.split(uri);
        return base;
    }

    routerUrl(uri: string): string {
        return join(this.baseUrl, uri);
    }
}
